import styled from '@emotion/styled';

import { COLORS, mq } from '@clutter/clean';

export const LearnMoreSection = styled.section`
  background: ${COLORS.cloud};
  padding: 80px 0;

  ${mq({
    padding: ['40px 0', '80px 0', '100px 0'],
  })}
`;

export const Container = styled.div`
  max-width: 1050px;
  margin: 0 auto;
  padding: 0 24px;

  ${mq({
    padding: ['0 20px', '0 24px', '0 32px'],
  })}
`;

export const SectionHeading = styled.h2`
  font-family: 'Recoleta', serif;
  font-size: 45px;
  font-weight: 500;
  color: ${COLORS.panther};
  text-align: left;
  margin-bottom: 24px;
  line-height: 1.4;

  ${mq({
    fontSize: ['32px', '40px', '45px'],
    marginBottom: ['15px', '40px', '24px'],
    textAlign: ['left', 'left', 'left'],
  })}
`;

export const TabsContainer = styled.div`
  display: flex;
  gap: 24px;
  margin-bottom: 40px;
  flex-wrap: wrap;

  ${mq({
    gap: ['12px', '16px', '18px'],
    marginBottom: ['32px', '40px', '40px'],
    justifyContent: ['flex-start', 'flex-start', 'flex-start'],
    flexWrap: ['nowrap', 'nowrap', 'wrap'],
    overflowX: ['auto', 'auto', 'visible'],
    paddingBottom: ['8px', '8px', '0px'],
  })}

  /* Scrollbar styling for mobile */
  @media (max-width: 767px) {
    &::-webkit-scrollbar {
      height: 4px;
    }
    &::-webkit-scrollbar-track {
      background: #f1f1f1;
      border-radius: 2px;
    }
    &::-webkit-scrollbar-thumb {
      background: #c1c1c1;
      border-radius: 2px;
    }
    &::-webkit-scrollbar-thumb:hover {
      background: #a8a8a8;
    }
  }

  @media (min-width: 768px) and (max-width: 1023px) {
    &::-webkit-scrollbar {
      height: 4px;
    }
    &::-webkit-scrollbar-track {
      background: #f1f1f1;
      border-radius: 2px;
    }
    &::-webkit-scrollbar-thumb {
      background: #c1c1c1;
      border-radius: 2px;
    }
    &::-webkit-scrollbar-thumb:hover {
      background: #a8a8a8;
    }
  }
`;

export const TabButton = styled.button<{ active: boolean }>`
  padding: 12px 24px;
  border-radius: 32px;
  border: none;
  font-family: 'Basier Square', sans-serif;
  font-weight: 500;
  font-size: 20px;
  line-height: 1.2;
  cursor: pointer;
  transition: all 0.3s ease;
  white-space: nowrap;
  min-width: 161px;
  height: 48px;
  flex-shrink: 0;

  ${({ active }) =>
    active
      ? `
        background: #1B9089;
        color: ${COLORS.cloud};
        box-shadow: 0 4px 12px rgba(27, 144, 137, 0.3);
      `
      : `
        background: #E4E4E4;
        color: #4E4E4E;
        
        &:hover {
          background: ${COLORS.grayBorder};
        }
      `}

  ${mq({
    padding: ['10px 16px', '12px 24px', '12px 24px'],
    fontSize: ['20px', '18px', '20px'],
    minWidth: ['auto', '150px', '161px'],
    height: ['48px', '44px', '48px'],
  })}
`;

export const CardsContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
  gap: 24px;

  ${mq({
    gridTemplateColumns: [
      'repeat(auto-fit, minmax(250px, 1fr))',
      'repeat(auto-fit, minmax(280px, 1fr))',
      'repeat(auto-fit, minmax(280px, 1fr))',
    ],
    gap: ['20px', '22px', '24px'],
  })}
`;

export const BenefitCard = styled.div`
  display: flex;
  padding: var(--M, 24px);
  flex-direction: column;
  align-items: flex-start;
  gap: var(--M, 24px);
  flex: 1 0 0;
  background: ${COLORS.tealBackground};
  border-radius: 24px;
  position: relative;
  transition:
    transform 0.3s ease,
    box-shadow 0.3s ease;

  &:hover {
    transform: translateY(-4px);
    box-shadow: 0 12px 32px rgba(0, 0, 0, 0.1);
  }

  ${mq({
    padding: ['var(--M, 24px)', 'var(--M, 24px)', 'var(--M, 24px)'],
    borderRadius: ['20px', '22px', '24px'],
  })}
`;

export const IconContainer = styled.div`
  width: 40px;
  height: 40px;
  border-radius: 16px;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  margin-bottom: 0px;

  svg {
    width: 32px;
    height: 32px;
    color: ${COLORS.cloud};
  }

  img {
    width: 100%;
    height: 100%;
    object-fit: contain;
    padding: 0px;
  }

  ${mq({
    width: ['40px', '40px', '40px'],
    height: ['40px', '40px', '40px'],
    marginBottom: ['0px', '28px', '0px'],
    borderRadius: ['12px', '14px', '16px'],
  })}
`;

export const CardTitle = styled.h3`
  font-family: 'Recoleta', serif;
  font-size: 28px;
  font-weight: 500;
  color: #000000;
  margin-bottom: 16px;
  line-height: 1.4;

  ${mq({
    fontSize: ['28px', '26px', '28px'],
    marginBottom: ['0px', '14px', '0px'],
  })}
`;

export const CardDescription = styled.p`
  font-family: 'Basier Square', sans-serif;
  font-size: 18px;
  font-weight: 400;
  line-height: 1.4;
  color: ${COLORS.storm};
  margin: 0;

  ${mq({
    fontSize: ['20px', '17px', '18px'],
  })}
`;
